import { Component, Inject, OnInit } from '@angular/core';
import { DashboardService } from '../../dashboard.service';
import { Dashboard } from "src/shared/models/dashboard.model";
import { NavigationService } from 'src/app/navigation/navigation.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';
import { NotificationService } from 'src/app/notifications/notification.service';
import { AnalyticsService, ConfigurationService } from '@niceltd/cxone-client-platform-services';
import { DOCUMENT } from '@angular/common';

@Component({
    selector: 'cv-cxone-dashboard-content',
    templateUrl: './cxone-dashboard-content.component.html',
    styleUrls: ['./cxone-dashboard-content.component.scss']
})
export class CxoneDashboardContentComponent implements OnInit {

    constructor(
        public dashboardService: DashboardService,
        public navigationService: NavigationService,
        public cvLocalizationService: CVLocalizationService,
        private cvConfigurationService: CvConfigurationService,
        private notificationService: NotificationService,
        private cxAnalytics: AnalyticsService,
        private cxConfig: ConfigurationService,
        @Inject(DOCUMENT) private document: Document,
    ) {
        window.addEventListener('beforeunload', (e) => {
            const needConfirmationToClose = this.dashboardService.dashboards.some(d => d?.NeedConfirmationToClose);

            if (needConfirmationToClose) {
                e.preventDefault();
                e.returnValue = '';
                return;
            }

            delete e['returnValue'];
        });


        // force cxone when on cxone dashboard
        this.cvConfigurationService.isCxOne = true;
        this.navigationService.displayModules = 'responsive';
    }

    ngOnInit(): void {
        this.document.body.classList.add('cx-one-ui');
    }

    /** Verify if a given dashboard is currently active */
    public isActiveDashboard(dashboard: Dashboard): boolean {
        if (dashboard) return this.dashboardService.activeDashboard.key === dashboard.DashboardKey;
        else return this.dashboardService.activeDashboard.key == null;
    }
}
